import { DotLegalHeader, DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { BaseViewModel } from "../../../system/systemOverview/SystemOverview.types";
import { Box } from "@mui/material";

export interface ILegalEntitiesColumn {
    legalEntities: Array<BaseViewModel>;
    emptyText?: string;
}

function LegalEntitiesColumn(props: ILegalEntitiesColumn) {
    if (props.legalEntities.length === 0) {
        return props.emptyText;
    }

    const content = (
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            {props.legalEntities.length > 0 && props.legalEntities[0].name}
            {props.legalEntities.length > 1 && (
                <Box ml={"4px"} marginTop={-0.2}>
                    <DotLegalHeader headerStyle={"extraSmall"} marginBottom={0}>
                        {" "}
                        + {props.legalEntities.length - 1}
                    </DotLegalHeader>
                </Box>
            )}
        </Box>
    );

    if (props.legalEntities.length > 1) {
        const tooltip = (
            <Box>
                {props.legalEntities.map((x, i) => (
                    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }} key={x.id + i}>
                        {x.name}
                    </Box>
                ))}
            </Box>
        );
        return <DotLegalTooltip text={tooltip}>{content}</DotLegalTooltip>;
    }
    return content;
}

export default LegalEntitiesColumn;
